import React, { useRef, useState } from "react";
import styles from "./Offering.module.css";

const OfferingPage = () => {
  // Helper function for image paths
  const getImagePath = (imageName) =>
    process.env.PUBLIC_URL + "/images/" + imageName;

  const [isHidden, setIsHidden] = useState(true);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [dashboardImageIndex, setDashboardImageIndex] = useState(0);
  const [revenueImageIndex, setRevenueImageIndex] = useState(0);
  const [retentionImageIndex, setRetentionImageIndex] = useState(0);
  const menuRef = useRef(null);

  const comparisonImages = [
    {
      src: getImagePath("loan_offer_1.jpg"),
      alt: "Loan Comparisons",
      link: "#",
      caption: "Loan Products",
    },
    {
      src: getImagePath("loan_offer_2.jpg"),
      alt: "Interest Calculator",
      link: "#",
      caption: "Personal Loan Form",
    },
    {
      src: getImagePath("loan_offer_3.jpg"),
      alt: "Quick Eligibility",
      link: "#",
      caption: "Loan Offers",
    },
    {
      src: getImagePath("loan_offer_4.jpg"),
      alt: "Bank Partnerships",
      link: "#",
      caption: "Part Payment Details",
    },
    {
      src: getImagePath("loan_offer_5.jpg"),
      alt: "Bank Partnerships",
      link: "#",
      caption: "PreClosure Details",
    },
  ];

  const dashboardImages = [
    {
      src: getImagePath("borrower_1.jpg"),
      alt: "Dashboard View 1",
      caption: "Create Lead",
    },
    {
      src: getImagePath("borrower_2.jpg"),
      alt: "Dashboard View 2",
      caption: "Leads Management",
    },
    {
      src: getImagePath("borrower_4.jpg"),
      alt: "Dashboard View 3",
      caption: "Credit Information Report",
    },
    {
      src: getImagePath("borrower_3.jpg"),
      alt: "Dashboard View 3",
      caption: "Bank Statement Analysis",
    },
  ];

  const revenueImages = [
    {
      src: getImagePath("Earn.png"),
      alt: "Revenue View 1",
    },
    // {
    //   src: getImagePath("offering1.png"),
    //   alt: "Revenue View 2",
    // },
    // {
    //   src: getImagePath("offering1.png"),
    //   alt: "Revenue View 3",
    // },
  ];

  const retentionImages = [
    {
      src: getImagePath("portpolio_3.jpg"),
      alt: "Retention View 2",
      caption: "Loan Portfolio",
    },
    {
      src: getImagePath("portpolio_1.jpg"),
      alt: "Retention View 1",
      caption: "Portfolio Dashboard",
    },
    {
      src: getImagePath("portpolio_2.jpg"),
      alt: "Retention View 2",
      caption: "Credit Health Dashboard",
    },
    // {
    //   src: getImagePath("offering1.png"),
    //   alt: "Retention View 3",
    // },
  ];

  const toggleMenuItemClick = (e) => {
    e.preventDefault();
    setIsHidden((prevState) => !prevState);
  };

  const handlePrevImage = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? comparisonImages.length - 1 : prevIndex - 1
    );
  };

  const handleNextImage = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setCurrentImageIndex(
      (prevIndex) => (prevIndex + 1) % comparisonImages.length
    );
  };

  const handlePrevDashboardImage = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDashboardImageIndex((prevIndex) =>
      prevIndex === 0 ? dashboardImages.length - 1 : prevIndex - 1
    );
  };

  const handleNextDashboardImage = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDashboardImageIndex(
      (prevIndex) => (prevIndex + 1) % dashboardImages.length
    );
  };

  const handlePrevRevenueImage = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setRevenueImageIndex((prevIndex) =>
      prevIndex === 0 ? revenueImages.length - 1 : prevIndex - 1
    );
  };

  const handleNextRevenueImage = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setRevenueImageIndex((prevIndex) => (prevIndex + 1) % revenueImages.length);
  };

  const handlePrevRetentionImage = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setRetentionImageIndex((prevIndex) =>
      prevIndex === 0 ? retentionImages.length - 1 : prevIndex - 1
    );
  };

  const handleNextRetentionImage = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setRetentionImageIndex(
      (prevIndex) => (prevIndex + 1) % retentionImages.length
    );
  };

  return (
    <div className={`${styles.pageContainer} relative`}>
      <div
        className={`${styles.container} relative overflow-hidden flex flex-column`}
      >
        {/* Navigation */}
        <div className={`${styles.navigation} px-4 md:px-8 py-4 relative`}>
          <div className="flex align-items-center justify-content-between w-full">
            {/* Logo on far left */}
            <div className="flex align-items-center select-none">
              <a href="/app">
                <img
                  src={getImagePath("headerlogo2.png")}
                  alt="Interesting"
                  className={styles.headerLogo}
                />
              </a>
            </div>

            {/* Mobile menu toggle - only visible on mobile */}
            <button
              onClick={toggleMenuItemClick}
              className="cursor-pointer block lg:hidden border-none bg-transparent p-2"
              type="button"
              aria-label="Toggle menu"
            >
              <i className={`${styles.mobileMenuIcon} pi pi-bars text-2xl`}></i>
            </button>

            {/* Desktop Navigation */}
            <div
              className={`${styles.desktopNav} hidden lg:flex align-items-center justify-content-between`}
            >
              {/* Center menu items */}
              <div className="flex align-items-center justify-content-center flex-grow-1">
                <ul className="list-none p-0 m-0 flex align-items-center select-none">
                  <li className="mx-3">
                    <a
                      href="/app/offering"
                      className={`${styles.menuItem} ${styles.activeMenuItem} p-ripple flex align-items-center font-medium cursor-pointer transition-colors transition-duration-150 py-2`}
                    >
                      <span>Offering</span>
                    </a>
                  </li>
                  <li className="mx-3">
                    <a
                      href="/app/pricing"
                      className={`${styles.menuItem} p-ripple flex align-items-center font-medium cursor-pointer transition-colors transition-duration-150 py-2`}
                    >
                      <span>Pricing</span>
                    </a>
                  </li>
                  {/* <li className="mx-3">
                    <a
                      href="#why-us"
                      className={`${styles.menuItem} p-ripple flex align-items-center font-medium cursor-pointer transition-colors transition-duration-150 py-2`}
                    >
                      <span>Why us</span>
                    </a>
                  </li>
                  <li className="mx-3">
                    <a
                      href="#ting"
                      className={`${styles.menuItem} p-ripple flex align-items-center font-medium cursor-pointer transition-colors transition-duration-150 py-2`}
                    >
                      <span>Ting</span>
                    </a>
                  </li> */}
                  <li className="mx-3">
                    <a
                      href="https://interestng.com/app/contact"
                      className={`${styles.menuItem} p-ripple flex align-items-center font-medium cursor-pointer transition-colors transition-duration-150 py-2`}
                    >
                      <span>Contact us</span>
                    </a>
                  </li>
                </ul>
              </div>

              {/* CTA button on far right */}
              <div className="flex align-items-center">
                <a
                  href="https://app.interestng.com/app/login"
                  className={styles.heroCta1}
                >
                  Login
                </a>
              </div>
            </div>

            {/* Mobile menu - only shows on mobile when toggled */}
            {!isHidden && (
              <div
                className={`${styles.mobileMenu} block lg:hidden absolute top-full left-0 w-full shadow-2`}
              >
                <ul className="list-none p-0 m-0 flex flex-column">
                  <li>
                    <a
                      href="/app/offering"
                      className={`${styles.mobileMenuItem} p-ripple flex px-4 py-3 align-items-center font-medium cursor-pointer`}
                    >
                      <span>Offering</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="/app/pricing"
                      className={`${styles.mobileMenuItem} p-ripple flex px-4 py-3 align-items-center font-medium cursor-pointer`}
                    >
                      <span>Pricing</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="#why-us"
                      className={`${styles.mobileMenuItem} p-ripple flex px-4 py-3 align-items-center font-medium cursor-pointer`}
                    >
                      <span>Why us</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="#ting"
                      className={`${styles.mobileMenuItem} p-ripple flex px-4 py-3 align-items-center font-medium cursor-pointer`}
                    >
                      <span>Ting</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://interestng.com/app/contact"
                      className={`${styles.mobileMenuItem} p-ripple flex px-4 py-3 align-items-center font-medium cursor-pointer`}
                    >
                      <span>Contact us</span>
                    </a>
                  </li>
                  <li className="p-3">
                    <a
                      href="https://app.interestng.com/app/login"
                      className={styles.ctaButton2}
                    >
                      Login
                    </a>
                  </li>
                </ul>
              </div>
            )}
          </div>
        </div>
        <img
          src={getImagePath("Cover.png")}
          alt="Cover"
          className={styles.leftCoverImage}
          style={{
            position: "absolute",
            top: "10px",
            left: "-20px",
            zIndex: 10,
            width: "350px",
            height: "auto",
          }}
        />
        {/* All Main Sections Container */}
        <div className={styles.allSectionsContainer}>
          {/* Left Side Cover Image */}

          {/* Right Side Offer Image */}
          <img
            src={getImagePath("offer.png")}
            alt="Offer"
            className={styles.rightOfferImage}
            style={{
              position: "absolute",
              top: "-90px",
              right: "-10px",
              zIndex: 10,
              width: "800px",
              height: "auto",
            }}
          />

          {/* Hero Section */}
          <div className={`${styles.heroSection} px-4 md:px-8 py-8`}>
            <div className="text-center mb-8">
              <h1 className={`${styles.heroTitle} mb-4`}>Our Offerings</h1>
              <p className={`${styles.heroSubtitle} mx-auto`}>
                Your all-in-one platform for the entire loan journey — from
                smart comparison to seamless conversion.
              </p>
            </div>
          </div>

          {/* Comparison Table Section */}
          <div className={`${styles.comparisonSection} px-4 md:px-8 py-8`}>
            <div className={`grid align-items-center ${styles.comparisonGrid}`}>
              <div
                className={`col-12 md:col-6 ${styles.comparisonImageColumn}`}
              >
                <div className={styles.comparisonImageWrapper}>
                  <div
                    style={{
                      position: "relative",
                      width: "100%",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        transition: "transform 0.5s ease-in-out",
                        transform: `translateX(-${currentImageIndex * 100}%)`,
                      }}
                    >
                      {comparisonImages.map((image, index) => (
                        <div
                          key={index}
                          style={{ minWidth: "100%", position: "relative" }}
                        >
                          <img
                            src={image.src}
                            alt={image.alt}
                            className="w-full"
                            style={{ cursor: "default" }}
                          />
                          {image.caption && (
                            <p
                              style={{
                                textAlign: "center",
                                marginTop: "12px",
                                fontSize: "14px",
                                fontWeight: "500",
                                color: "#6B7280",
                              }}
                            >
                              {image.caption}
                            </p>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Image dots indicator */}
                  <div
                    style={{
                      marginTop: "20px",
                      display: "flex",
                      justifyContent: "center",
                      gap: "10px",
                      paddingBottom: "10px",
                    }}
                  >
                    {comparisonImages.map((_, index) => (
                      <button
                        key={index}
                        onClick={() => setCurrentImageIndex(index)}
                        style={{
                          width: "12px",
                          height: "12px",
                          borderRadius: "50%",
                          border: "none",
                          backgroundColor:
                            index === currentImageIndex ? "#1F49E3" : "#D1D5DB",
                          cursor: "pointer",
                          transition: "all 0.3s ease",
                          transform:
                            index === currentImageIndex
                              ? "scale(1.2)"
                              : "scale(1)",
                        }}
                        aria-label={`Go to slide ${index + 1}`}
                      />
                    ))}
                  </div>
                </div>
              </div>
              <div
                className={`col-12 md:col-5 ${styles.comparisonContentColumn}`}
              >
                <div className={styles.comparisonContent}>
                  <h2 className={styles.comparisonTitle}>
                    Loan Comparisons in Half a Minute
                  </h2>
                  <p className={styles.comparisonSubtitle}>
                    Get side-by-side comparisons from 60+ banks, NBFCs, and
                    fintechs — right at your fingertips
                  </p>

                  <div className={styles.comparisonFeatures}>
                    <p className={styles.comparisonFeatureTitle}>
                      Easily share with borrowers:
                    </p>
                    <ul className={styles.comparisonList}>
                      <li>Total payment and interest savings across banks</li>
                      <li>Tenure reductions with part payments</li>
                      <li>
                        Flexible repayment options tailored to their profile
                      </li>
                    </ul>
                  </div>

                  <div className={styles.comparisonButtons}>
                    <button
                      className={styles.prevButton}
                      onClick={(e) => {
                        e.preventDefault();
                        console.log("Previous button clicked");
                        handlePrevImage(e);
                      }}
                      type="button"
                      aria-label="Previous slide"
                      style={{
                        cursor: "pointer",
                        zIndex: 10,
                        position: "relative",
                      }}
                    >
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ pointerEvents: "none" }}
                      >
                        <path
                          d="M16 12H8M8 12L11 9M8 12L11 15"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                    <button
                      className={styles.nextButton}
                      onClick={(e) => {
                        e.preventDefault();
                        console.log("Next button clicked");
                        handleNextImage(e);
                      }}
                      type="button"
                      aria-label="Next slide"
                      style={{
                        cursor: "pointer",
                        zIndex: 10,
                        position: "relative",
                      }}
                    >
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ pointerEvents: "none" }}
                      >
                        <path
                          d="M8 12H16M16 12L13 9M16 12L13 15"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Borrower Dashboard Section */}
          <div className={`${styles.dashboardSection} px-4 md:px-8 py-8`}>
            <div className={`grid align-items-center ${styles.dashboardGrid}`}>
              <div
                className={`col-12 md:col-6 p-0 ${styles.dashboardContentColumn}`}
              >
                <div className={styles.dashboardContent}>
                  <h2 className={`${styles.dashboardTitle} mb-4`}>
                    Borrower Dashboard
                  </h2>
                  <p className={`${styles.dashboardSubtitle} mb-4`}>
                    Stay ahead with clear, actionable borrower
                    <br className="hidden md:block" />
                    intelligence.
                  </p>
                  <ul className={styles.dashboardFeatureList}>
                    <li>Complete financial and credit profile</li>
                    <li>Real-time & fast eligibility</li>
                    <li>Impact employment & ID verification</li>
                  </ul>

                  <div className={styles.comparisonButtons}>
                    <button
                      className={styles.prevButton}
                      onClick={(e) => {
                        e.preventDefault();
                        handlePrevDashboardImage(e);
                      }}
                      type="button"
                      aria-label="Previous slide"
                      style={{
                        cursor: "pointer",
                        zIndex: 10,
                        position: "relative",
                      }}
                    >
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ pointerEvents: "none" }}
                      >
                        <path
                          d="M16 12H8M8 12L11 9M8 12L11 15"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                    <button
                      className={styles.nextButton}
                      onClick={(e) => {
                        e.preventDefault();
                        handleNextDashboardImage(e);
                      }}
                      type="button"
                      aria-label="Next slide"
                      style={{
                        cursor: "pointer",
                        zIndex: 10,
                        position: "relative",
                      }}
                    >
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ pointerEvents: "none" }}
                      >
                        <path
                          d="M8 12H16M16 12L13 9M16 12L13 15"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>

              <div
                className={`col-12 md:col-6 p-0 ${styles.dashboardImageColumn}`}
              >
                <div className={styles.dashboardImageWrapper}>
                  <div
                    style={{
                      position: "relative",
                      width: "100%",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        transition: "transform 0.5s ease-in-out",
                        transform: `translateX(-${dashboardImageIndex * 100}%)`,
                      }}
                    >
                      {dashboardImages.map((image, index) => (
                        <div
                          key={index}
                          style={{ minWidth: "100%", position: "relative" }}
                        >
                          <img
                            src={image.src}
                            alt={image.alt}
                            className="w-full"
                            style={{ cursor: "default" }}
                          />
                          {image.caption && (
                            <p
                              style={{
                                textAlign: "center",
                                marginTop: "12px",
                                fontSize: "14px",
                                fontWeight: "500",
                                color: "#6B7280",
                              }}
                            >
                              {image.caption}
                            </p>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Image dots indicator - moved outside and below image box */}
                <div
                  style={{
                    marginTop: "30px",
                    display: "flex",
                    justifyContent: "center",
                    gap: "10px",
                    paddingBottom: "10px",
                  }}
                >
                  {dashboardImages.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => setDashboardImageIndex(index)}
                      style={{
                        width: "12px",
                        height: "12px",
                        borderRadius: "50%",
                        border: "none",
                        backgroundColor:
                          index === dashboardImageIndex ? "#1F49E3" : "#D1D5DB",
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                        transform:
                          index === dashboardImageIndex
                            ? "scale(1.2)"
                            : "scale(1)",
                      }}
                      aria-label={`Go to slide ${index + 1}`}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Earn Revenue Section */}
          <div className={`${styles.revenueSection} px-4 md:px-8 py-8`}>
            <div className={`grid align-items-center ${styles.revenueGrid}`}>
              <div className={`col-12 md:col-5 ${styles.revenueImageColumn}`}>
                <div className={styles.revenueImageWrapper}>
                  <div
                    style={{
                      position: "relative",
                      width: "100%",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        transition: "transform 0.5s ease-in-out",
                        transform: `translateX(-${revenueImageIndex * 100}%)`,
                      }}
                    >
                      {revenueImages.map((image, index) => (
                        <div
                          key={index}
                          style={{ minWidth: "100%", position: "relative" }}
                        >
                          <img
                            src={image.src}
                            alt={image.alt}
                            className="w-full"
                            style={{ cursor: "default" }}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Image dots indicator - moved outside and below image box */}
                <div
                  style={{
                    marginTop: "30px",
                    display: "flex",
                    justifyContent: "center",
                    gap: "10px",
                    paddingBottom: "10px",
                  }}
                >
                  {revenueImages.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => setRevenueImageIndex(index)}
                      style={{
                        width: "12px",
                        height: "12px",
                        borderRadius: "50%",
                        border: "none",
                        backgroundColor:
                          index === revenueImageIndex ? "#1F49E3" : "#D1D5DB",
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                        transform:
                          index === revenueImageIndex
                            ? "scale(1.2)"
                            : "scale(1)",
                      }}
                      aria-label={`Go to slide ${index + 1}`}
                    />
                  ))}
                </div>
              </div>
              <div className={`col-12 md:col-6 ${styles.revenueContentColumn}`}>
                <div className={styles.revenueContent}>
                  <h2 className={`${styles.revenueTitle} mb-4`}>
                    Earn Revenue
                  </h2>
                  <p className={`${styles.revenueSubtitle} mb-4`}>
                    Turn every approval over the line earnings with
                    <br className="hidden md:block" />
                    Interestng's agent-first dashboard.
                  </p>
                  <ul className={styles.revenueFeatureList}>
                    <li>Track leads, approvals, and disbursals in one place</li>
                    <li>
                      See bank-wise and product-wise performance at a glance
                    </li>
                    <li>Monitor commissions earned in real time</li>
                    <li>
                      Stay on top of payouts, targets, and team performance
                    </li>
                  </ul>

                  <div className={styles.comparisonButtons}>
                    <button
                      className={styles.prevButton}
                      onClick={(e) => {
                        e.preventDefault();
                        handlePrevRevenueImage(e);
                      }}
                      type="button"
                      aria-label="Previous slide"
                      style={{
                        cursor: "pointer",
                        zIndex: 10,
                        position: "relative",
                      }}
                    >
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ pointerEvents: "none" }}
                      >
                        <path
                          d="M16 12H8M8 12L11 9M8 12L11 15"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                    <button
                      className={styles.nextButton}
                      onClick={(e) => {
                        e.preventDefault();
                        handleNextRevenueImage(e);
                      }}
                      type="button"
                      aria-label="Next slide"
                      style={{
                        cursor: "pointer",
                        zIndex: 10,
                        position: "relative",
                      }}
                    >
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ pointerEvents: "none" }}
                      >
                        <path
                          d="M8 12H16M16 12L13 9M16 12L13 15"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Customer Retention Section */}
          <div className={`${styles.retentionSection} px-4 md:px-8 py-8`}>
            <div className={`grid align-items-center ${styles.retentionGrid}`}>
              <div
                className={`col-12 md:col-5 ${styles.retentionContentColumn}`}
              >
                <div className={styles.retentionContent}>
                  <h2 className={`${styles.retentionTitle} mb-4`}>
                    Customer Retention with
                    <br className="hidden md:block" />
                    Portfolio Intelligence
                  </h2>
                  <p className={`${styles.retentionSubtitle} mb-4`}>
                    Turn one-time borrowers into lifelong customers
                  </p>
                  <ul className={styles.retentionFeatureList}>
                    <li>Get a complete view of all active loans</li>
                    <li>
                      Track EMIs, outstanding balances & maturity timelines
                    </li>
                    <li>Spot refinance or cross-sell opportunities</li>
                    <li>
                      Strengthen trust by guiding borrowers on repayment &
                      renewals
                    </li>
                  </ul>

                  <div className={styles.comparisonButtons}>
                    <button
                      className={styles.prevButton}
                      onClick={(e) => {
                        e.preventDefault();
                        handlePrevRetentionImage(e);
                      }}
                      type="button"
                      aria-label="Previous slide"
                      style={{
                        cursor: "pointer",
                        zIndex: 10,
                        position: "relative",
                      }}
                    >
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ pointerEvents: "none" }}
                      >
                        <path
                          d="M16 12H8M8 12L11 9M8 12L11 15"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                    <button
                      className={styles.nextButton}
                      onClick={(e) => {
                        e.preventDefault();
                        handleNextRetentionImage(e);
                      }}
                      type="button"
                      aria-label="Next slide"
                      style={{
                        cursor: "pointer",
                        zIndex: 10,
                        position: "relative",
                      }}
                    >
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ pointerEvents: "none" }}
                      >
                        <path
                          d="M8 12H16M16 12L13 9M16 12L13 15"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
              <div className={`col-12 md:col-6 ${styles.retentionImageColumn}`}>
                <div className={styles.retentionImageWrapper}>
                  <div
                    style={{
                      position: "relative",
                      width: "100%",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        transition: "transform 0.5s ease-in-out",
                        transform: `translateX(-${retentionImageIndex * 100}%)`,
                      }}
                    >
                      {retentionImages.map((image, index) => (
                        <div
                          key={index}
                          style={{ minWidth: "100%", position: "relative" }}
                        >
                          <img
                            src={image.src}
                            alt={image.alt}
                            className="w-full"
                            style={{ cursor: "default" }}
                          />
                          {image.caption && (
                            <p
                              style={{
                                textAlign: "center",
                                marginTop: "12px",
                                fontSize: "14px",
                                fontWeight: "500",
                                color: "#6B7280",
                              }}
                            >
                              {image.caption}
                            </p>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Image dots indicator - moved outside and below image box */}
                <div
                  style={{
                    marginTop: "30px",
                    display: "flex",
                    justifyContent: "center",
                    gap: "10px",
                    paddingBottom: "10px",
                  }}
                >
                  {retentionImages.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => setRetentionImageIndex(index)}
                      style={{
                        width: "12px",
                        height: "12px",
                        borderRadius: "50%",
                        border: "none",
                        backgroundColor:
                          index === retentionImageIndex ? "#1F49E3" : "#D1D5DB",
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                        transform:
                          index === retentionImageIndex
                            ? "scale(1.2)"
                            : "scale(1)",
                      }}
                      aria-label={`Go to slide ${index + 1}`}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>{" "}
        {/* End of All Main Sections Container */}
        {/* Final CTA Section */}
        <div className={`${styles.finalCtaSection} relative`}>
          <img
            src={getImagePath("Cover.png")}
            alt="Cover"
            className="absolute top-4 left-4"
            style={{ width: "200px", height: "auto", zIndex: 0 }}
          />
          <img
            src={getImagePath("Group1000004784.png")}
            alt="CTA Background Shape"
            className="absolute top-0 right-0"
            style={{ width: "70%", height: "100%", zIndex: 0 }}
          />
          <div
            className={`${styles.ctaContent} px-4 md:px-8 py-8 text-center`}
            style={{ position: "relative", zIndex: 10 }}
          >
            <h2 className={`${styles.ctaTitle} mb-4 mx-auto`}>
              Let's Stop Losing Deals Together
            </h2>
            <p className={`${styles.ctaSubtitle} mb-4 mx-auto`}>
              You're already doing the hard work.
              <br />
              Now join Interesting to win smarter, faster,
              <br />
              and more often.
            </p>
            <a href="/app/login" className={styles.ctaButton}>
              Login
            </a>
            <div
              className={`${styles.ctaAgents} flex align-items-center justify-content-center mt-4`}
            >
              <div className={styles.agentAvatars}>
                <img
                  src={getImagePath("join1.png")}
                  alt="Agent"
                  className={styles.agentAvatar}
                />
                <img
                  src={getImagePath("join2.png")}
                  alt="Agent"
                  className={styles.agentAvatar}
                />
                <img
                  src={getImagePath("join3.png")}
                  alt="Agent"
                  className={styles.agentAvatar}
                />
              </div>
              <p className={`${styles.agentText} ml-3`}>
                Join 500+ successful agents
              </p>
            </div>
          </div>
        </div>
        {/* Footer */}
        <footer className={styles.footer}>
          <div className="px-4 md:px-8 py-8">
            <div className="grid">
              <div className="col-12 md:col-6">
                <div className="mb-6">
                  <h3 className={styles.footerBrand}>
                    Interestng™ — Life is Dull
                    <br />
                    When You Lose Deals
                  </h3>
                  <div className={styles.footerLogoContainer}>
                    <img
                      src={getImagePath("footerLogo.svg")}
                      alt="Interesting Logo"
                      className={styles.footerLogoImage}
                    />
                  </div>
                </div>
              </div>
              <div className="col-12 md:col-6">
                <div className="grid">
                  <div className="col-4">
                    <ul className="list-none p-0 m-0">
                      <li className="mb-3">
                        <a href="/app" className={styles.footerLink}>
                          Home
                        </a>
                      </li>
                      <li className="mb-3">
                        <a href="/app/offering" className={styles.footerLink}>
                          Offering
                        </a>
                      </li>
                      <li className="mb-3">
                        <a href="/app/pricing" className={styles.footerLink}>
                          Pricing
                        </a>
                      </li>
                      {/* <li className="mb-3">
                        <a href="#why-us" className={styles.footerLink}>
                          Why Us
                        </a>
                      </li> */}

                      <li className="mb-3">
                        <a href="#service" className={styles.footerLink}>
                          Service
                        </a>
                      </li>

                      <li className="mb-3">
                        <a href="#faq" className={styles.footerLink}>
                          FAQ
                        </a>
                      </li>

                      {/* <li className="mb-3">
                        <a href="#ting" className={styles.footerLink}>
                          Ting
                        </a>
                      </li> */}
                    </ul>
                  </div>
                  <div className="col-4">
                    <ul className="list-none p-0 m-0">
                      {/* <li className="mb-3">
                        <a href="#faq" className={styles.footerLink}>
                          FAQ
                        </a>
                      </li> */}
                      <li className="mb-3">
                        <a href="/app/about" className={styles.footerLink}>
                          About Us
                        </a>
                      </li>
                      <li className="mb-3">
                        <a href="/app/contact" className={styles.footerLink}>
                          Contact us
                        </a>
                      </li>

                      <li className="mb-3">
                        <a
                          href="/app/terms-and-conditions"
                          className={styles.footerLink}
                        >
                          Terms & Conditions
                        </a>
                      </li>
                      <li className="mb-3">
                        <a
                          href="/app/privacy-policy"
                          className={styles.footerLink}
                        >
                          Privacy Policy
                        </a>
                      </li>
                      <li className="mb-3">
                        <a
                          href="/app/refund-policy"
                          className={styles.footerLink}
                        >
                          Refund-Policy
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default OfferingPage;
